<template>
  <div class="detailedBox">
    <el-form class="withdrawalBoxSearch" :model="withdrawalSearch" ref="form" :inline="true">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-select v-model="withdrawalSearch.status" placeholder="状态" style="width:100%;" clearable @change="getSearchWithdrawalData(1)">
            <el-option v-for="item in stateDictDate" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-input v-model="withdrawalSearch.orderSn" placeholder="请输入订单号搜索" @keyup.enter.native="getSearchWithdrawalData(1)"></el-input>
        </el-col>
        <el-col :span="4">
          <div @click="withdrawExport">
            <el-button type="primary" class="NbImportBotton">导出数据</el-button>
            <form action="https://test.dancebox.cn/api/v1/admin/sponsor_withdraw/export_excel" class="importInput" method="get" id="myform">
              <input type="hidden" name="status" :value="withdrawalSearch.status">
              <input type="hidden" name="num" :value="withdrawalSearch.num">
            </form>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="withdrawalDataList" border style="width: 100%">
      <el-table-column prop="createdAt" label="申请时间" align="center">
        <template slot-scope="scope">
          <p>{{scope.row.createdAt | formatDate}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="orderSn" label="提现订单号" align="center"></el-table-column>
      <el-table-column prop="amount" label="提现金额（元）" align="center"></el-table-column>
      <el-table-column prop="type" label="提现方式" align="center">
        <template slot-scope="scope">
          <p>{{scope.row.type == 1 ? '微信提现': ''}}</p>
        </template>
      </el-table-column>
      <el-table-column label="到账账号" align="center">
        <template slot-scope="scope">
          <div class="clear">
            <img class="fl userImg" src="accountAvatar" alt="">
            <span class="fl userName">{{scope.row.accountName}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <p>{{getVal(scope.row.status)}}</p>
          <p style="color: red">{{scope.row.rejectReason}}</p>
        </template>
      </el-table-column>
    </el-table>
    <table-pagination :pageTotal="tableTotal" @handlePageChange="handlePageChange" />
  </div>
</template>

<script>
import { urlObjectParams, dateToString } from '@/utils';
import { prefix } from '@/api';
import axios from 'axios';
import { mapState, mapActions } from 'vuex';
export default {
  data () {
    return {
      withdrawalSearch: {
        status: null,
        orderSn: ""
      },
      page: {
        pageNumber: 1,
        pageSize: 10
      }
    }
  },
  created () {
    this.getSearchWithdrawalData()
  },
  computed: {
    ...mapState({
      withdrawalDataList: state => state.finance.withdrawalDataList,
      tableTotal: state => state.finance.withdrawalListTotal,
      stateDictDate: state => state.finance.stateDictDate,
      withdrawalSuccess: state => state.finance.withdrawalSuccess
    })
  },
  watch: {
    withdrawalSuccess(val) {
      if(val) {
        this.detailedSearch = {
          status: null,
          orderSn: ""
        }
        this.getSearchWithdrawalData(1)
      }
    }
  },
  methods: {
    ...mapActions(['getWithdrawalData']),
    getSearchWithdrawalData (num) {
      this.page.pageNumber = num ? num : this.page.pageNumber
      let data = {
        ...this.withdrawalSearch,
        ...this.page
      }
      this.getWithdrawalData(data)
    },
    getVal (key) {
      return this.stateDictDate.find(item => item.key == key).value;
    },
    handlePageChange (val) {
      this.page.pageNumber = val;
      this.getSearchWithdrawalData()
    },
    withdrawExport () {
      let queryOptions = {
        ...this.withdrawalSearch
      };
      axios({
        method: 'get',
        url: `${prefix}/admin/sponsor_withdraw/export_excel?${urlObjectParams(queryOptions)}`,
        responseType: 'blob'
      }).then(data => {
        const blob = new Blob([data], { type: 'application/ms-excel' });
        const elink = document.createElement('a');
        elink.download = `提现记录${dateToString(new Date())}.xlsx`;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }).catch(() => {
        // this.isShowDownload = false;
      })
      // document.getElementById('myform').submit()
    }
  }
}
</script>

<style lang="scss" scoped>
.withdrawalBoxSearch {
  margin-bottom: 20px;
}
</style>
